import FormModal from '@insurancemenu/imenu-components-lib/dist/components/modals/FormModal';
import React, { useEffect, useState } from 'react';
import { FileUpload } from '@insurancemenu/imenu-components-lib';
import { UPLOAD_FILE_TYPES } from '@insurancemenu/imenu-components-lib/dist/components/FileUpload';
import { observer } from 'mobx-react-lite';
import { UploadResponseDocumentModalStore } from 'store/pages/rfq/rfq-response/proposal-response/uploadResponseDocumentModalStore';
import { ModalType } from '@insurancemenu/imenu-components-lib/dist/helpers/ModalsHelper';
import { FormBodyWrapperStyled, InputTextStyled, TextAreaStyled } from './styles';

interface Props {
  show: boolean;
  onClose: () => void;
  modalStore: UploadResponseDocumentModalStore;
}

const UploadDocumentModal: React.FC<Props> = observer(({ show, onClose, modalStore }) => {
  const { isLoading, form, isDataValid, setFile, resetModal, requestUploadDocument } = modalStore;

  const [resetUiFile, setResetUiFile] = useState(false);

  useEffect(() => {
    setResetUiFile(false);
  }, [show]);

  const onSubmit = async (): Promise<void> => {
    onClose();
    await requestUploadDocument();
    setResetUiFile(true);
    resetModal();
  };

  function handleClose(): void {
    setResetUiFile(true);
    resetModal();
    onClose();
  }

  return (
    <FormModal
      show={show}
      title="Upload Document"
      modalType={ModalType.CREATION}
      loading={isLoading}
      formContent={
        <FormBodyWrapperStyled>
          <InputTextStyled
            label="Document Name"
            name="docName"
            value={form.fields.docName.value}
            onChange={form.onFieldChange}
            width="100%"
            validationPassed={!form.fields.docName.unpassedValidationMsg}
            validationMessage={form.fields.docName.unpassedValidationMsg}
          />
          <TextAreaStyled
            label="Description"
            name="description"
            value={form.fields.description.value}
            onChange={form.onFieldChange}
            width="100%"
          />
          <FileUpload
            onChange={setFile}
            fileMimeTypes={[
              UPLOAD_FILE_TYPES.xls,
              UPLOAD_FILE_TYPES.xlsx,
              UPLOAD_FILE_TYPES.doc,
              UPLOAD_FILE_TYPES.docx,
              UPLOAD_FILE_TYPES.tsv,
              UPLOAD_FILE_TYPES.pdf,
            ]}
            allowMultipleFiles={false}
            shouldBeReset={resetUiFile}
          />
        </FormBodyWrapperStyled>
      }
      closeButtonText="Cancel"
      submitButtonText="Upload"
      isFormValid={isDataValid}
      onSubmit={onSubmit}
      onClose={handleClose}
    />
  );
});

export default UploadDocumentModal;
